import React, { useState } from 'react'
import loginIcons from '../assest/signin.gif'
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from 'react-router-dom';
import SummaryApi from '../common';
import { toast } from 'react-toastify';
import certificate from '../assest/certificate.gif'
import uploadImage from '../helpers/uploadImage';
import { useEffect } from 'react';
import ROLE from '../common/role';
import { useSelector } from 'react-redux';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';


const SignUp = () => {
  const [showPassword,setShowPassword] = useState(false)
  const [showConfirmPassword,setShowConfirmPassword] = useState(false)
  const [data,setData] = useState({
      email : "",
      password : "",
      name : "",
      confirmPassword : "",
      profilePic : "",
      shippingAddress :"",
      certificatePic: "",
      pharmacistOrPharmacy: "pharmacy", 
      mobileNumber: "", 
      governorate: "", 
      region: "", 
      purchasingManager: ""
  })
  const navigate = useNavigate()
  const user = useSelector(state => state?.user?.user);
  const [loading, setLoading] = useState(false);

  const handleOnChange = (e) =>{
      const { name , value } = e.target

     setData((prev) => {
      
      if (name === 'governorate' && value !== 'طرابلس') {
        return {
          ...prev,
          [name]: value,
          region: "" 
        };
      }
      return {
        ...prev,
        [name]: value
      };
    });
  };
  

  const handleUploadPic = async(e) =>{
    const file = e.target.files[0]
    
    const uploadImageCloudinary = await uploadImage(file);
    
    setData((preve)=>{
      return{
        ...preve,
        profilePic : uploadImageCloudinary.url
      }
    })

  }
  const handleUploadCertificate = async (e) => {
    const file = e.target.files[0];
    const uploadImageCloudinary = await uploadImage(file);
    setData((prev) => ({
      ...prev,
      certificatePic: uploadImageCloudinary.url
    }));
  };

  const handleSubmit = async(e) =>{
      e.preventDefault()

      if (data.governorate === 'طرابلس' && !data.region) {
        toast.error("يجب اختيار المنطقة عند اختيار طرابلس.");
        return;
      }
      /*
      if (!data.certificatePic && data.pharmacistOrPharmacy==='pharmacy') {
        toast.error("يجب رفع صورة الشهادة قبل إنشاء الحساب.");
        return;
      }
        
      if (data.pharmacistOrPharmacy === 'pharmacist') {
        data.certificatePic = ''; 
      }
        */

      data.certificatePic = ''; 

      if(data.password === data.confirmPassword){

        const dataResponse = await fetch(SummaryApi.signUP.url,{
            method : SummaryApi.signUP.method,
            headers : {
                "content-type" : "application/json"
            },
            body : JSON.stringify(data)
          })
    
          const dataApi = await dataResponse.json()

          if(dataApi.success){
            toast.success(dataApi.message)
        
        const emailVerificationResponse = await fetch(SummaryApi.userMailSendVerification.url, {
            method: SummaryApi.userMailSendVerification.method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: data.email })
          });
  
          const emailVerificationData = await emailVerificationResponse.json();
  
          if (emailVerificationData.success) {
            toast.success("تم ارسال رمز التحقق علي هذا البريد الالكترونى");
            // Navigate to the email verification page
            navigate("/UserVerifyEmail", { state: { email: data.email } });
          } else {
            toast.error(emailVerificationData.message);
          }
        } else if (dataApi.error) {
          toast.error(dataApi.message);
        }
      } else {
        toast.error("من فضلك تاكد من كلمة المرور وتاكيد كلمة المرور");
      }
    };

        
    useEffect(() => {
      setLoading(true);
      if (user) {
          if(user?.role === ROLE.GENERAL){
              navigate("/");
              setLoading(false);
          }

         else if (user?.role === ROLE.ADMIN) {
              if (user?.type === "Medicine") {
                  navigate("/admin-home");
                  setLoading(false);
              } 
              else if(user?.type === "Cosmetic") {
                  navigate("/admin-cosmetic-home");
                  setLoading(false);
              }
              else if (user?.type ==="Admin"){
                  navigate("/admin-panel/all-users");
                  setLoading(false);
              }
              
          } 

          else if (user?.role === ROLE.SALESMAN) {
      
            navigate("/salesManPanel/salesManViewOrders");
            setLoading(false);
  
        }
          
          else {
              setLoading(false);
          }
      } else {
          setLoading(false);
      }
  }, [user, navigate]);


  if (loading) {
      return (
          <div className="flex justify-center items-center h-screen">
              <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
          </div>
      );
  }
       

  return (
    <section id='signup'>
        <div className='mx-auto container p-4'>

            <div className='bg-white p-5 w-full max-w-sm mx-auto'>

                    <div className='w-20 h-20 mx-auto relative overflow-hidden rounded-full'>
                        <div>
                            <img src={data.profilePic || loginIcons} alt='login icons'/>
                        </div>
                        <form>
                          <label>
                            <div className='text-xs bg-opacity-80 bg-slate-200 pb-4 pt-2 cursor-pointer text-center absolute bottom-0 w-full'>
                              ادخل صورةالحساب
                            </div>
                            <input type='file' className='hidden' onChange={handleUploadPic}/>
                          </label>
                        </form>
                    </div>

                    <form className='pt-6 flex flex-col gap-2 text-right' onSubmit={handleSubmit}>
                      <div className='grid'>
                              <label>: اسم الصيدلية / العميل </label>
                              <div className='bg-slate-100 p-2'>
                                  <input 
                                      type='text' 
                                      placeholder='ادخل الاسم' 
                                      name='name'
                                      value={data.name}
                                      onChange={handleOnChange}
                                      required
                                      className='w-full h-full outline-none bg-transparent'/>
                              </div>
                          </div>
                        <div className='grid'>
                            <label>: البريد الالكتروني </label>
                            <div className='bg-slate-100 p-2'>
                                <input 
                                    type='email' 
                                    placeholder='ادخل البريد الالكتروني' 
                                    name='email'
                                    value={data.email}
                                    onChange={handleOnChange}
                                    required
                                    className='w-full h-full outline-none bg-transparent'/>
                            </div>
                        </div>
                        
                                                <div className='grid'>
                        <label className='mb-6 text-bg text-right block'>: نوع الحساب</label>
                        <div className='flex justify-center space-x-16'>
                            <div className='flex items-center'>
                            <input 
                                type='radio' 
                                id='pharmacy' 
                                name='pharmacistOrPharmacy' 
                                value='pharmacy' 
                                checked={data.pharmacistOrPharmacy === 'pharmacy'}
                                onChange={handleOnChange}
                                className='accent-blue-500 mr-2'
                            />
                            <label htmlFor='pharmacy' className='text-bg'>صيدلية</label>
                            </div>
                            
                            <div className='flex items-center'>
                            <input 
                                type='radio' 
                                id='pharmacist' 
                                name='pharmacistOrPharmacy' 
                                value='pharmacist' 
                                checked={data?.pharmacistOrPharmacy === 'pharmacist'}
                                onChange={handleOnChange}
                                className='accent-blue-500 mr-2'
                            />
                            <label htmlFor='pharmacist' className='text-bg '>عميل</label>
                            </div>
                        </div>
                        </div>
                        {data?.pharmacistOrPharmacy==='pharmacy' &&(
                        <div className='grid'>
                              <label>: اسم مدير المشتريات </label>
                              <div className='bg-slate-100 p-2'>
                                  <input 
                                      type='text' 
                                      placeholder='ادخل اسم مدير المشتريات' 
                                      name='purchasingManager'
                                      value={data?.purchasingManager}
                                      onChange={handleOnChange}
                                      required
                                      className='w-full h-full outline-none bg-transparent'/>
                              </div>
                          </div>
                          )}




                        <div className='grid'>
                              <label>: عنوان التوصيل</label>
                              <div className='bg-slate-100 p-2'>
                                  <input 
                                      type='text' 
                                      placeholder='ادخل عنوان التوصيل' 
                                      name='shippingAddress'
                                      value={data.shippingAddress}
                                      onChange={handleOnChange}
                                      required
                                      className='w-full h-full outline-none bg-transparent'/>
                              </div>
                          </div>
                        <div>
                            <label>: كلمة المرور </label>
                            <div className='bg-slate-100 p-2 flex'>
                                <input 
                                    type={showPassword ? "text" : "password"} 
                                    placeholder='ادخل كلمة المرور'
                                    value={data.password}
                                    name='password' 
                                    onChange={handleOnChange}
                                    required
                                    className='w-full h-full outline-none bg-transparent'/>
                                <div className='cursor-pointer text-xl' onClick={()=>setShowPassword((preve)=>!preve)}>
                                    <span>
                                        {
                                            showPassword ? (
                                                <FaEye/>
                                            )
                                            :
                                            (
                                                <FaEyeSlash/>
                                            )
                                        }
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div>
                            <label>: تاكيد كلمة المرور </label>
                            <div className='bg-slate-100 p-2 flex'>
                                <input 
                                    type={showConfirmPassword ? "text" : "password"} 
                                    placeholder='ادخل تاكيد كلمة المرور'
                                    value={data.confirmPassword}
                                    name='confirmPassword' 
                                    onChange={handleOnChange}
                                    required
                                    className='w-full h-full outline-none bg-transparent'/>

                                <div className='cursor-pointer text-xl' onClick={()=>setShowConfirmPassword((preve)=>!preve)}>
                                    <span>
                                        {
                                            showConfirmPassword ? (
                                                <FaEye/> 
                                            )
                                            :
                                            (
                                                <FaEyeSlash/>
                                            )
                                        }
                                    </span>
                                </div>
                            </div>
                        </div>

                         {/* Mobile Number Input */}
            <div className='grid'>
              <label>: رقم الهاتف المحمول</label>
              <div className='bg-slate-100 p-2'>
                <input
                  type='tel'
                  pattern='[0-9]*'
                  placeholder='ادخل رقم الهاتف المحمول'
                  name='mobileNumber'
                  value={data.mobileNumber}
                 
                  onChange={handleOnChange}
                  required
                  className='w-full h-full outline-none bg-transparent'
                />
              </div>
            </div>

            {/* Governorate Dropdown */}
            <div className='grid'>
              <label>: المدينة</label>
              <select
                name='governorate'
                value={data.governorate}
                onChange={handleOnChange}
                required
                className='bg-slate-100 p-2 w-full outline-none'
              >
                <option value='' disabled>اختر المدينة</option>
                <option value='طرابلس'>طرابلس</option>
                <option value='بني غازي'>بني غازي</option>
                <option value='مصراتة'>مصراتة</option>
                <option value='الزاوية'>الزاوية</option>
                <option value='زليتن'>زليتن</option>
                <option value='الخمس'>الخمس</option>
                <option value='ترهونة'>ترهونة</option>
                <option value='قربولي'>قربولي</option>
                <option value='الجنوب'>الجنوب</option>
                <option value='منطقة اخري'>منطقة اخري</option>
              </select>
            </div>

            {/* Conditionally show the region dropdown if governorate is طرابلس */}
            {data.governorate === 'طرابلس' && (
              <div className='grid'>
                <label>: المنطقة</label>
                <select
                  name='region'
                  value={data.region}
                  onChange={handleOnChange}
                  className='bg-slate-100 p-2 w-full outline-none'
                >
                  <option value='' disabled>اختر المنطقة</option>
                  <option value='وسط المدينة'>وسط المدينة</option>
                  <option value='حي الاندلس'>حي الاندلس</option>
                  <option value='قرقارش'>قرقارش</option>
                  <option value='جنزور'>جنزور</option>
                  <option value='غوط الشغال'>غوط الشغال</option>
                  <option value='سوق الجمعة'>سوق الجمعة</option>
                  <option value='تاجوراء'>تاجوراء</option>
                  <option value='قصر بن غشير'>قصر بن غشير</option>
                  <option value='سبيعة'> سبيعة </option>
                  <option value='عين زارة'>عين زارة</option>
                  <option value='الهضبة'>الهضبة</option>
                  <option value='ابوسليم'>ابوسليم</option>
                  <option value='الفرناج'>الفرناج</option>
                </select>
              </div>
            )}

            {/*
            {data.pharmacistOrPharmacy==='pharmacy'&&
                                <div className='grid'>
                        <label>: شهادة التوثيق</label>
                        <div className='w-20 h-20 mx-auto relative overflow-hidden rounded-full'>
                            <div>
                                <img src={data.certificatePic || certificate} alt='Certificate Icon' />
                            </div>
                            <form>
                                <label>
                                    <div className='text-xs bg-opacity-35 bg-slate-200 pb-1 pt-2 cursor-pointer text-center absolute bottom-0 w-full'>
                                        ادخل صورة الشهادة
                                    </div>
                                    <input type='file' className='hidden' onChange={handleUploadCertificate} />
                                </label>
                            </form>
                        </div>
                                        

                    </div>
                  }
                    */}



                        <button className='bg-blue-900  hover:bg-blue-800  text-white px-6 py-2 w-full max-w-[150px] rounded hover:scale-110 transition-all mx-auto block mt-6'>إنشاء حساب</button>

                    </form>

                    <p className='my-5 text-right'>هل لديك حساب  بالفعل ؟ <Link to={"/login"} className=' text-blue-900 hover:text-blue-800 hover:underline'>تسجيل الدخول</Link></p>
            </div>


        </div>
    </section>
  )
}

export default SignUp